/**
 * Library structures come back from the backend as JPA entities, so each one
 * carries its WHOLE `breakdownStructures` set — including the SCENARIO-scoped
 * buckets the Generative Workspace creates when a queue is generated (Excel
 * import, "Add to queue", Ask AI). Those buckets carry `scenarioId != null`
 * (see `BreakdownStructure.scenarioId`, migration
 * V1_57_20__breakdown_structure_scenario_scope) and are already excluded from
 * `/breakdown-structure`, the catalogue My Knowledge renders.
 *
 * Leaving them on the structure made the Scoping library grow one folder per
 * generated run (STR_AA_NT1_C01_B01, …) next to the two real library entries.
 * Strip them at the boundary so every library consumer — tree, counts,
 * `breakdownStructures[0]` primary lookups — sees library rows only.
 */

export const isLibraryBreakdown = (breakdown) =>
  breakdown != null && breakdown.scenarioId == null;

export function stripScenarioBreakdowns(structures) {
  if (!Array.isArray(structures)) return structures;
  return structures.map((structure) => {
    const breakdowns = structure?.breakdownStructures;
    if (!Array.isArray(breakdowns)) return structure;
    const libraryOnly = breakdowns.filter(isLibraryBreakdown);
    return libraryOnly.length === breakdowns.length
      ? structure
      : { ...structure, breakdownStructures: libraryOnly };
  });
}
